// extracted by mini-css-extract-plugin
export var bodySections = "_6g-8";
export var gray = "_6g-7";
export var green = "_6g-4";
export var iconContainer = "_6g-9";
export var iconWidgetContainer = "_6g-1";
export var phoneIcon = "_6g-2";
export var red = "_6g-5";
export var statusDot = "_6g-3";
export var widgetContainer = "_6g-0";
export var yellow = "_6g-6";